<template>
  <div class="payment-detail">
    <p class="payment-detail__title">
      Detalle de la transacción
    </p>
    <div
      v-for="data in tables"
      :key="data.folio"
    >
      <div class="info__row">
        <span class="left">Transacción:</span>
        <span class="text-success">
          APROBADA
        </span>
      </div>
      <div class="info__row">
        <span class="left">Teléfono:</span>
        <span>{{ data.phone }}</span>
      </div>
      <div class="info__row">
        <span class="left">Monto pagado:</span>
        <span>          {{ data.amount }}        </span>
      </div>
      <div class="info__row">
        <span class="left">Número de autorización:</span>
        <span> {{ data.authCode }} </span>
      </div>
      <div class="info__row">
        <span class="left">Fecha y hora:</span>
        <span>{{ data.operationDate | localHour }}</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PaymentDetail',
  props: { paymentInfo: { type: Object, required: true }, money: { type: String, required: true } },
  data() {
    return {
      tables: this.paymentInfo.successInfo.invoicesInfo.map(
        ({ formattedClientId, total, folio }) => ({
          folio,
          phone: formattedClientId,
          amount: this.formatMoney(total, this.money, 2),
          authCode: this.paymentInfo.successInfo.authCode,
          operationDate: this.paymentInfo.successInfo.operationDate
        })
      )
    };
  },
  methods: {
    formatMoney(amount, currency, decimals) {
      return `${currency} ${(amount + 0).toFixed(decimals)}`;
    }
  }
};
</script>

<style lang="scss">
$brownish-grey: rgb(102, 102, 102);
.payment-detail {
  display: grid;
  border-top: 1px solid rgba(0,0,0,.1);
}

.payment-detail__title {
  font-size: 1.2rem;
  font-weight: bold;
  margin: 1rem 0;
  text-align: left;
}

.info__row {
  display: flex;
  justify-content: space-between;
  .left {
    font-weight: bold;
    color: $brownish-grey;
  }
}
</style>
